import React, { useState } from 'react';
import DrawerRight from 'src/componets/DrawerRight';
import GroupUpload from 'src/componets/FileDropzone/GroupUpload';
import watcherApi from 'src/api/watcherApi';
import { Switch, Upload } from 'antd';
import { FolderOutlined } from '@ant-design/icons';

interface Props {
  open: boolean;
  prefix: string;
  bucketId: string;
  onClose: () => void;
  onSuccess: () => void;
}

const UploadDrawer = ({ open, prefix, bucketId, onClose, onSuccess }: Props) => {
  const [folderMode, setFolderMode] = useState(false);

  function handleUploadSuccess() {
    onSuccess();
  }

  const IGNORED_FILES = ['.DS_Store', 'Thumbs.db', 'desktop.ini'];

  function beforeUpload(file: any) {
    if (IGNORED_FILES.includes(file.name)) {
      return Upload.LIST_IGNORE;
    }
    return true;
  }

  function folderData(file: any) {
    const relativePath = file.webkitRelativePath || '';
    const parts = relativePath.split('/');
    parts.pop(); // remove filename
    const subPath = parts.length ? parts.join('/') + '/' : '';
    const data: Record<string, string> = { prefix: prefix ? prefix + subPath : subPath };
    if (bucketId) data.bucket_id = bucketId;
    return data;
  }

  return (
    <DrawerRight
      open={open}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h6 className='v-content-label' style={{ margin: 0 }}>
          {folderMode ? 'Upload Folder' : 'Upload Files'}
        </h6>
        <span>
          <Switch
            size='small'
            checked={folderMode}
            onChange={setFolderMode}
          /> <FolderOutlined /> Folder
        </span>
      </div>

      <GroupUpload
        key={folderMode ? 'folder' : 'files'}
        name='file'
        directory={folderMode}
        action={watcherApi.oneSky.url('/onesky/r2_files')}
        headers={watcherApi.oneSky.uploadHeaders}
        data={folderMode ? folderData : { prefix, ...(bucketId ? { bucket_id: bucketId } : {}) }}
        beforeUpload={beforeUpload}
        onSuccess={handleUploadSuccess}
        listType='picture'
      />
    </DrawerRight>
  );
};

export default UploadDrawer;
